import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { COMMON, JOB } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

/** POST `common/job` — shared job dropdown options. */
export const fetchCommonJobOptions = async (data = {}) => {
  try {
    const response = await POST(COMMON.JOB, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getJobList = async (data = array()) => {
  try {
    const url = data?._Id ? `${JOB.GET_JOB_LIST}/${data?._Id}` : `${JOB.GET_JOB_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addJob = async (data = array()) => {
  try {
    const response = await POST(JOB.ADD_JOB, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateJob = async (id, data = array()) => {
  try {
    const url = `${JOB.GET_JOB_LIST}`;
    const response = await POST(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getJobDataById = async (data = array()) => {
  try {
    const url = data?.Id ? `${JOB.GET_JOB_LIST}/${data?.Id}` : `${JOB.GET_JOB_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchJobTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id ? `${JOB.GET_JOB_SCHEMA}/${data?._Id}` : `${JOB.GET_JOB_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitFilterData = async (data = array()) => {
  try {
    const response = await POST(JOB.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitPackageFilterData = async (data = array()) => {
  try {
    const response = await POST(JOB.SUBMIT_PACKAGE_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** Maps `common/fadv-package` / `common/fadv-package-multi` rows (`{ id, display }`) to react-select options. */
export const mapFadvPackageApiToSelectOptions = (payload) => {
  const list = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload)
      ? payload
      : [];
  return list
    .map((item) => {
      const value = String(item?.id ?? item?.value ?? "").trim();
      const label = String(item?.display ?? item?.label ?? item?.name ?? value).trim();
      return value ? { value, label } : null;
    })
    .filter(Boolean);
};

/** POST `common/fadv-package` — body `{ primaryIds: null | string[] }`. */
export const getFadvPackageOptions = async (data = {}) => {
  try {
    const response = await POST(COMMON.FADV_PACKAGE, {
      primaryIds: data?.primaryIds ?? null,
    });
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `common/fadv-package-multi` — body `{ primaryIds: null, selected: string[] }`. */
export const getFadvPackageMultiOptions = async (data = {}) => {
  try {
    const response = await POST(COMMON.FADV_PACKAGE_MULTI, {
      primaryIds: data?.primaryIds ?? null,
      selected: Array.isArray(data?.selected) ? data.selected : [],
    });
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** Maps `master/AIJobType/filter` rows to react-select options.
 * Response shape: `{ data: { records: [{ id, aiJobTypeName, ... }] } }`.
 */
export const mapAIJobTypeApiToSelectOptions = (payload) => {
  const list = Array.isArray(payload?.data?.records)
    ? payload.data.records
    : Array.isArray(payload?.data)
      ? payload.data
      : Array.isArray(payload?.records)
        ? payload.records
        : Array.isArray(payload)
          ? payload
          : [];
  return list
    .map((item) => {
      const value = String(item?.id ?? item?.aiJobTypeId ?? item?.value ?? "").trim();
      const label = String(
        item?.aiJobTypeName ?? item?.name ?? item?.display ?? item?.label ?? value
      ).trim();
      return value ? { value, label } : null;
    })
    .filter(Boolean);
};

/** POST `master/AIJobType/filter` — body `{}`. */
export const getAIJobTypeOptions = async (data = {}) => {
  try {
    const response = await POST(JOB.SUBMIT_AI_JOB_TYPE_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
